module.exports = __webpack_public_path__ + "img/bg-1.4f692e10.jpg";